import type { ApiFilestackImageData } from '#/api/types/ApiFilestackImageData';
import { Box } from '#/components/Box/Box';
import { Button } from '#/components/Button/Button';
import { Icon } from '#/components/Icon/Icon';
import { BodySmall } from '#/components/Text/BodySmall';
import { useI18n } from '#/i18n/hooks/useI18n';
import { isDefined } from '#/utils/functional/type';

import { DropBox } from './DropBox';
import { OverlayDropContent } from './OverlayDropContent';

type Props = {
  id?: string;
  image: ApiFilestackImageData | null | undefined;
  message: string;
  onClick: () => void;
};

export function ImagePickerOverlayButton({
  id,
  image,
  message,
  onClick,
}: Props) {
  const { i18n } = useI18n();

  return (
    <>
      <DropBox
        position="absolute"
        top={0}
        left={0}
        p={10}
        width="100%"
        height="100%"
        $overlayButton
        $hasImage={isDefined(image)}
      >
        <div style={{ height: '100%' }}>
          <OverlayDropContent
            height="100%"
            width="100%"
            display="flex"
            flexDirection="column"
            alignItems="center"
            justifyContent="center"
            p="6px 16px"
            opacity={image ? 0 : 1}
          >
            <div>
              <Icon name="upload" size={23} />
            </div>

            <BodySmall my={0} ml="8px">
              {message}
            </BodySmall>
          </OverlayDropContent>
        </div>
      </DropBox>

      {image && (
        <Box
          position="absolute"
          zIndex={1}
          bottom="20px"
          left="50%"
          transform="translateX(-50%)"
        >
          <Button
            type="button"
            variant="primary"
            id={id}
            size="small"
            onClick={onClick}
          >
            {i18n('Replace')}
          </Button>
        </Box>
      )}
    </>
  );
}
